import React from "react";
import BrandSection from "../BrandSection/BrandSection";
import "./Brands.css";

const Brands = () => {
  return (
    <div className="brands-page">
      <div className="brands-hero">
        <h1>Our Lending Partners</h1>
        <p>Discover the innovative financial solutions across our portfolio of trusted brands</p>
      </div>
      <BrandSection />
    </div>
  );
};

export default Brands;

